module.exports = __webpack_public_path__ + "static/media/p9.bc1c0fca.jpeg";